const words = ["Orden", "Cuentas Claras", "Transparencia", "Canarias", "Tranquilidad", "Atención Cercana"];

export default function Marquee() {
  const row = [...words, ...words];
  return (
    <div
      data-testid="editorial-marquee"
      className="border-y border-slate-100 py-8 sm:py-10 overflow-hidden select-none"
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((w, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display font-extrabold uppercase tracking-tight text-4xl sm:text-6xl text-outline px-6">
                  {w}
                </span>
                <span className="w-2 h-2 rounded-full bg-slate-300" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
